import React from 'react';
import { SearchProps } from 'antd/lib/input/Search';

import {
  StyledAntdInputSearch,
} from './style';

const CVSearch = (props: SearchProps): JSX.Element => (
  <StyledAntdInputSearch {...props} />
);

export default CVSearch;
